import { useSelector } from "react-redux";
import { BrandLogo } from "@/components/brand";
import { getSubdomain } from "../helpers/helpers";
import { lawyerSelectors } from "../redux/lawyer/selectors";
import { firmConfiguration } from "../constans";

export const NavBarLogo = () => {
  const lawyer = useSelector(lawyerSelectors.selectAll);
  const subdomain = getSubdomain();
  const isCaseblink = !Object.keys(firmConfiguration).includes(subdomain);
  if (isCaseblink) return <BrandLogo className="h-8" />;
  if (lawyer.lawFirmLogo) {
    return <img src={lawyer.lawFirmLogo} alt="" className="h-8 w-auto" />;
  }
  return null;
};
